import React, { useEffect } from 'react';
import './home.css'
import Moon from './moon.js'


export default function EventsHome() {
    useEffect(()=>{
        let countDownDate = new Date("Dec 31, 2022 23:59:59").getTime();
        // console.log(countDownDate);

        let counter = setInterval(() => {
        // Get Date Now
        let dateNow = new Date().getTime();

        // Find The Date Difference Between Now And Countdown Date
        let dateDiff = countDownDate - dateNow;

        // Get Time Units
        // let days = Math.floor(dateDiff / 1000 / 60 / 60 / 24);
        let days = Math.floor(dateDiff / (1000 * 60 * 60 * 24));
        let hours = Math.floor((dateDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        let minutes = Math.floor((dateDiff % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((dateDiff % (1000 * 60)) / 1000);

        document.querySelector(".days").innerHTML = days < 10 ? `0${days}` : days;
        document.querySelector(".hours").innerHTML = hours < 10 ? `0${hours}` : hours;
        document.querySelector(".minutes").innerHTML = minutes < 10 ? `0${minutes}` : minutes;
        document.querySelector(".seconds").innerHTML = seconds < 10 ? `0${seconds}` : seconds;

        if (dateDiff < 0) {
            clearInterval(counter);
        }
        }, 1000);
    })

    return(
        <div>
            {/* <!-- Start Events --> */}
            <div class="events" id="events">

            <div class="dots dots-up"></div>
            <div class="dots dots-down"></div>
            <Moon/>
            <h2 class="main-title">Latest Events</h2>
           
            <div class="container">
                {/* <img src="imgs/events.png" alt="" /> */}
                <div class="info">
                <div class="time">
                    <div class="unit">
                    <span class="days">15</span>
                    <span>Days</span>
                    </div>
                    <div class="unit">
                    <span class="hours">08</span>
                    <span>Hours</span>
                    </div>
                    <div class="unit">
                    <span class="minutes">45</span>
                    <span>Minutes</span>
                    </div>
                    <div class="unit">
                    <span class="seconds">55</span>
                    <span>Seconds</span>
                    </div>
                </div>
                <h2 class="title">Planetarium Visit</h2>
                <p class="description">
                    By the end of this year, an excusrion to Nehru Planetarium, Delhi is 
                    planned by the society to promote such events and bonds among 
                    people having similar interests.
                </p>
                </div>
                <div style={{textAlign:'center'}} class="subscribe">
                {/* <form action=""> */}
                    {/* <input type="email" placeholder="Enter Your Email" /> */}
                    <a href="https://www.instagram.com/nakshatra_nsut/" target='_blank' className='registerButton'>Register</a>
                {/* </form> */}
                </div>
            </div>
            </div>

            {/* <Moon/> */}
            {/* <!-- End Events --> */}
        </div>
    )
}